export const modalCss = modalWidth => `
  max-width: 100%;
  width: 100%;

  @media (min-width: 768px) {
    width: ${modalWidth};
  }

  h1, h2, h3, h4, h5, h6 {
    color: #223254 !important;
    font-weight: bold !important;
  }

  h1, h2 {
    font-size: 20px !important;
  }

  h3 {
    font-size: 18px !important;
  }

  h4, h5, h6 {
    font-size: 14px !important;
  }

  .modal {
    &-thumbnail {
      display: block;
      margin: 0 auto 20px;
    }

    &-title {
      font-size: 20px;
      color: #223254;
    }

    &-field {
      margin: 16px 0;

      h1, h2, h3, h4, h5, h6, label {
        font-size: 14px;
        color: #6e798e;
        font-weight: 600;
      }
    }

    &-loader-container {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 24px;

      i {
        width: 48px;
        height: 48px;
      }
    }

    &-buttons {
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-end;
      align-items: center;
      margin-top: 8px;

      > button {
        display: flex;
        align-items: center;
        justify-content: center;
        flex: 0;
        padding: 12px 24px;
        margin-left: 16px;
        min-width: 110px;

        &:disabled {
          background: #d8dcde;
          box-shadow: none;
          color: #879395;
        }

        i {
          width: 34px;
          height: 34px;
        }
      }
    }
  }
`;

export const modalSteps = (step, total) => `
  flex: 1;
  height: 8px;
  background: #d8d8d8;
  border-radius: 50px;
  position: relative;
  overflow: hidden;
  transition: all .3s;

  &:after {
    position: absolute;
    content: ' ';
    height: 100%;
    width: ${(step / total) * 100}%;
    background: #1abc9c;
    border-radius: 20px;
    transition: all .3s;
  }
`;